import { defineMessages } from 'react-intl';

export const scope = 'app.components.CustomDropzone';

export default defineMessages({
  fileTooBig: {
    id: `${scope}.fileTooBig`,
    defaultMessage: 'This file is too big. The maximum size is {maxSize}.',
    description:
      'Error when a chosen file exceeds the upload size limit; maxSize is a size such as 15MB',
  },
  unsupportedFileType: {
    id: `${scope}.unsupportedFileType`,
    defaultMessage: 'This file type is not supported. Try again!',
    description:
      'Error when a chosen file has a type the upload does not accept',
  },
});
